// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"mr_downloadButton__2Edq1"};